export default __webpack_public_path__ + "static/henna1-f5290c542dafa0cefc55c625a8c53d61.png";